export default __webpack_public_path__ + "static/media/zoom.8ba9ee37.svg";